import * as Sentry from "@sentry/react";
import type { RuntimeConfig } from "./config";

// Sentry stays off until a DSN is configured. Message content must never reach it:
// bodies, breadcrumb data and request payloads are dropped before sending.
export function initSentry(config: RuntimeConfig) {
  if (!config.sentryDsn) return;
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.env,
    release: config.release,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
    tracesSampleRate: 0,
    beforeBreadcrumb(crumb) {
      if (crumb.category === "console" || crumb.category === "ui.input") return null;
      return { ...crumb, data: undefined };
    },
    beforeSend(event) {
      if (event.request) {
        event.request.data = undefined;
        event.request.cookies = undefined;
        // The link callback carries a link token in its query.
        if (event.request.url) event.request.url = event.request.url.split("?")[0];
      }
      return event;
    },
  });
}
